import React from "react";
import { PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const PageHeaderTitle = ({ title }) => {
    const theme = useTheme();
    return (React.createElement(PeekTypography, { variant: "h1", fontWeight: theme.typography.fontWeightMedium }, title));
};
export default PageHeaderTitle;
